import { createFileRoute } from '@tanstack/react-router';
import { pixelDefaults, pixelsList, productionsList } from '@/api/resources';
import { warm, warmBackground } from '@/api/loaders';
import { requireSession } from '@/lib/route-guards';
import { useSetViewShim } from '@/lib/use-set-view';
import { PixelsView } from '@/screens/pixels';

export const Route = createFileRoute('/backend/pixels')({
  validateSearch: (s: Record<string, unknown>): { focus?: string } => ({
    focus: typeof s.focus === 'string' ? s.focus : undefined,
  }),
  beforeLoad: requireSession,
  loader: ({ context }) => {
    warmBackground(context.queryClient, pixelDefaults(undefined), productionsList({}));
    return warm(context.queryClient, pixelsList({}));
  },
  component: Page,
});

function Page() {
  const setView = useSetViewShim();
  const { focus } = Route.useSearch();
  return <PixelsView setView={setView} focus={focus} />;
}
